import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Alert from '@mui/material/Alert';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import TuneIcon from '@mui/icons-material/Tune';
import HistoryIcon from '@mui/icons-material/History';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useAuth } from '../../contexts/AuthContext';
import { PageHeader } from '../../components/common/PageHeader';

const adminCards = [
  {
    title: 'Organizations',
    description: 'Manage all organizations on the platform',
    icon: <BusinessIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/admin/organizations',
  },
  {
    title: 'Users',
    description: 'View and manage user accounts and claims',
    icon: <PeopleIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/admin/users',
  },
  {
    title: 'Default Prompts',
    description: 'Configure system-wide default prompts',
    icon: <TuneIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/admin/prompts',
  },
  {
    title: 'Audit Logs',
    description: 'View organization audit activity',
    icon: <HistoryIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/organization/audit-logs',
  },
  {
    title: 'Knowledge Base',
    description: 'Manage system-wide RAG documents',
    icon: <MenuBookIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/admin/knowledge-base',
  },
  {
    title: 'System Health',
    description: 'Monitor service statuses and system metrics',
    icon: <MonitorHeartIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    to: '/admin/health',
  },
];

export function AdminDashboardPage() {
  const { user } = useAuth();

  if (!user?.superAdmin) {
    return (
      <Alert severity="warning" sx={{ m: 2 }}>
        You do not have permission to access the admin dashboard.
      </Alert>
    );
  }

  return (
    <Box>
      <PageHeader title="Admin Dashboard" subtitle="Platform management tools" />
      <Grid container spacing={3}>
        {adminCards.map((card) => (
          <Grid key={card.title} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card>
              <CardActionArea component={Link} to={card.to} sx={{ p: 1 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  {card.icon}
                  <Typography variant="h6" sx={{ mt: 1 }}>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: "text.secondary"
                  }}>
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
